import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  SHOW_SUCCESS_MESSAGE,
  API_STATUS_CODE,
  HIDE_ERROR_MESSAGE,
} from '../../constants/ActionTypes';

export const fetchSuccess = () => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SUCCESS,
    });
  };
};
export const fetchError = (error) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_ERROR,
      payload: error,
    });
  };
};

export const fetchStart = () => {
  return (dispatch) => {
    dispatch({
      type: FETCH_START,
    });
  };
};

export const showSuccessMessage = (message) => {
  return {
    type: SHOW_SUCCESS_MESSAGE,
    payload: message,
  };
};

export const fetchStatusCode = (statusCode) => {
  return {
    type: API_STATUS_CODE,
    payload: statusCode,
  };
};

export const hideErrorMessage = () => {
  return {
    type: HIDE_ERROR_MESSAGE,
  };
};
